var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11069 19.0707C2.50351 19.0707 2 18.5672 2 17.96V6.11264C2 5.50547 2.50351 5.00195 3.11069 5.00195C3.71787 5.00195 4.22138 5.50547 4.22138 6.11264V17.96C4.22138 18.5672 3.71787 19.0707 3.11069 19.0707Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.556 13.147C6.94882 13.147 6.44531 12.6435 6.44531 12.0363V6.11264C6.44531 5.50547 6.94882 5.00195 7.556 5.00195C8.16318 5.00195 8.66669 5.50547 8.66669 6.11264V12.0363C8.66669 12.6435 8.16318 13.147 7.556 13.147Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.556 19.0695C6.94882 19.0695 6.44531 18.566 6.44531 17.9588V16.4779C6.44531 15.8707 6.94882 15.3672 7.556 15.3672C8.16318 15.3672 8.66669 15.8707 8.66669 16.4779V17.9588C8.66669 18.566 8.16318 19.0695 7.556 19.0695Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4388 8.70425C15.8316 8.70425 15.3281 8.20074 15.3281 7.59356V6.11264C15.3281 5.50547 15.8316 5.00195 16.4388 5.00195C17.046 5.00195 17.5495 5.50547 17.5495 6.11264V7.59356C17.5495 8.20074 17.046 8.70425 16.4388 8.70425Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9935 19.0707C11.3863 19.0707 10.8828 18.5672 10.8828 17.96V6.11264C10.8828 5.50547 11.3863 5.00195 11.9935 5.00195C12.6007 5.00195 13.1042 5.50547 13.1042 6.11264V17.96C13.1042 18.5672 12.6007 19.0707 11.9935 19.0707Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4388 19.0708C15.8316 19.0708 15.3281 18.5673 15.3281 17.9601V12.0365C15.3281 11.4293 15.8316 10.9258 16.4388 10.9258C17.046 10.9258 17.5495 11.4293 17.5495 12.0365V17.9601C17.5495 18.5673 17.046 19.0708 16.4388 19.0708Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8919 19.0707C20.2848 19.0707 19.7812 18.5672 19.7812 17.96V6.11264C19.7812 5.50547 20.2848 5.00195 20.8919 5.00195C21.4991 5.00195 22.0026 5.50547 22.0026 6.11264V17.96C22.0026 18.5672 21.4991 19.0707 20.8919 19.0707Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.8c3176da.svg";
export { ForwardRef as ReactComponent };